import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { updateThemeConfig } from "../actions";

function WelcomeScreen() {
  // Initial editor state with empty content
  const {intro_content, previewForm} = useSelector((state) => ({
    intro_content : state['theme_config'].intro_content,
    previewForm: state.previewForm,
  }))
  const dispatch = useDispatch()
  function handleChange(value) {
    dispatch(updateThemeConfig('intro_content',value))
  }
  return (
    <>
    {
      !previewForm &&
        <div style={{backgroundColor:"#fff",paddingBottom:"20px"}}>
          <ReactQuill
            value={intro_content}
            onChange={handleChange}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike"],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image"],
                [{ align: [] }],
                ["clean"],
              ],
            }}
          />
        </div>
    }

      <div>
        {
          !previewForm &&
            <h3>Preview:</h3>
        }
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: intro_content }} />
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(WelcomeScreen);
